const {
  callAuthorizedGraphQLEndpoint,
} = require('../../../../../Module/graphQL')

export const helpSubmission = queryVars => {
  return callAuthorizedGraphQLEndpoint(
    `mutation ($input: HelpSubmissionInput!) {
      helpSubmission(input:$input){
        success
        internalStatus
      }
    }`,
    {
      input: queryVars,
    },
  )
}
